import type { PortEnv } from '../port-contract';
/** Geometry ports get fresh request state and cannot perform hidden I/O or draw dice. */
export function geometryEnvironment<D extends object>(deps: D): PortEnv<D> {
  const unsupported = (): never => { throw new Error('geometry:unsupported-io'); };
  return { deps, globals: {}, functionStatics: {}, rand: unsupported, now: () => 0, nowMicro: () => 0,
    out: unsupported, uuid: unsupported, uniqid: unsupported, exit: unsupported, warn: unsupported,
    randomBytes: unsupported, gmdate: unsupported, hrtime: () => 0 };
}
